import { FAIconName, Icon, Markdown, Text } from "@/ui/core";
import { HStack, VStack } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface TaskBasicDetailsProps {
  description?: string;
  duration: string;
  patientName?: string;
  testID: string;
  title: string;
}

const TaskBasicDetails = ({
  description,
  duration,
  patientName,
  testID,
  title,
}: TaskBasicDetailsProps) => {
  return (
    <VStack
      alignItems="flex-start"
      gap={12}
      paddingTop={LayoutToken.ContentPaddingHorizontal}
    >
      <Text testID={joinTestIDs(testID, "title")} variant="h4">
        {title}
      </Text>
      <VStack gap={6}>
        {patientName && (
          <HStack alignItems="center" gap={6}>
            <Icon
              color={ColorToken.NeutralSecondary}
              name={FAIconName.User}
              size="sm"
              testID={joinTestIDs(testID, "patient")}
            />
            <Text
              color={ColorToken.NeutralSecondary}
              testID={joinTestIDs(testID, "patient-name")}
              variant="caption"
            >
              For {patientName}
            </Text>
          </HStack>
        )}
        <HStack alignItems="center" gap={6}>
          <Icon
            color={ColorToken.NeutralSecondary}
            name={FAIconName.Clock}
            size="sm"
            testID={joinTestIDs(testID, "duration")}
          />
          <Text
            color={ColorToken.NeutralSecondary}
            testID={joinTestIDs(testID, "duration")}
            variant="caption"
          >
            {duration}
          </Text>
        </HStack>
      </VStack>
      {description && (
        <Markdown
          content={description}
          testID={joinTestIDs(testID, "description")}
        />
      )}
    </VStack>
  );
};

export default TaskBasicDetails;
export type { TaskBasicDetailsProps };
